
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class PsPromoDtGrid extends Serenity.EntityGrid<PsPromoDtRow, any> {
        protected getColumnsKey() { return PsPromoDtColumns.columnsKey; }
        protected getDialogType() { return PsPromoDtDialog; }
        protected getIdProperty() { return PsPromoDtRow.idProperty; }
        protected getInsertPermission() { return PsPromoDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPromoDtRow.localTextPrefix; }
        protected getService() { return PsPromoDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        
    }
}